import { en } from './en';
import { es } from './es';
import type { Copy, Lang } from './types';

export type { Copy, Lang } from './types';

export const dictionaries: Record<Lang, Copy> = { es, en };

export const SUPPORTED_LANGS: readonly Lang[] = ['es', 'en'] as const;

export function isLang(value: unknown): value is Lang {
  return value === 'es' || value === 'en';
}
